var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useAuthenticated } from "nate-react-api-helpers";
import { api } from "../../api/API";
import { useSocketNotifications } from "../WebSocketProvider";
import { useSnackbar } from "../Snackbar";
import { jsx as _jsx } from "react/jsx-runtime";
export const UserPreferencesContext = /*#__PURE__*/ createContext({ prefs: {}, set: () => { throw new Error("set: invalid context"); }, clear: () => { throw new Error("clear: invalid context"); }, reload: () => { throw new Error("reload: invalid context"); } });
export function useUserPreferences() { return useContext(UserPreferencesContext); }
export const userPrefChangedSocketKey = "user-preference:changed"; // Loads the current user's preferences once per login and keeps them in memory
// across navigations. Re-fetches when a preference changes (this tab or another).
// Children wait for the first load so hooks see the final value on mount.
export function UserPreferencesProvider(props) { const auth = useAuthenticated(); const snack = useSnackbar(); const [prefs, setPrefs] = useState(null); const loadCount = useRef(0); const reload = useCallback(() => __awaiter(this, void 0, void 0, function* () { const n = ++loadCount.current; try {
    const list = yield api.userPreferences.list({});
    if (n !== loadCount.current)
        return;
    const next = {};
    list.forEach(p => next[p.key] = p.value);
    setPrefs(next);
}
catch (e) {
    if (n !== loadCount.current)
        return;
    console.error(e);
    setPrefs({});
} }), []); useEffect(() => { if (!auth.authenticated) {
    loadCount.current++;
    setPrefs(null);
    return;
} reload(); }, [auth.authenticated, reload]); useSocketNotifications(userPrefChangedSocketKey, () => { reload(); }, [reload]); const upsert = useCallback((key, value, archived) => __awaiter(this, void 0, void 0, function* () { setPrefs(old => { const next = Object.assign({}, (old || {})); if (archived) {
    delete next[key];
}
else {
    next[key] = value;
} return next; }); try {
    yield api.userPreferences.upsert({ key, value, archived });
}
catch (e) {
    snack.error("Failed to save preference: " + e.toString());
    reload();
} }), [reload, snack]); const ctx = useMemo(() => ({ prefs: prefs || {}, set: (key, value) => upsert(key, value, false), clear: key => upsert(key, "", true), reload }), [prefs, upsert, reload]); if (auth.authenticated && prefs === null)
    return null; return /*#__PURE__*/ _jsx(UserPreferencesContext.Provider, { value: ctx, children: props.children }); }
